<div class="settings-tab">
  <form [formGroup]="passwordForm" class="settings-form">
    <div class="form-field">
      <label for="currentPassword">Enter Current Password</label>
      <mat-form-field>
        <input matInput formControlName="currentPassword" type="password" class="form-input" id="currentPassword" />
        @if (passwordForm.get('currentPassword')?.hasError('required')) {
          <mat-error>Current password is
          required</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-field">
      <label for="newPassword">Enter New Password</label>
      <mat-form-field>
        <input matInput formControlName="newPassword" type="password" class="form-input" id="newPassword"
          appPasswordViewer #passwordViewer="passwordViewer" />
          <app-password-toggle-button matSuffix [passwordViewer]="passwordViewer"></app-password-toggle-button>
        </mat-form-field>
        @if (passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid) {
          <mat-error class="mat-errors"
            >
            @if (passwordForm.get('newPassword')?.hasError('required')) {
              <div>
                Password is required.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('minlength')) {
              <div>
                Password must be at least 12 characters long.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('maxlength')) {
              <div>
                Password must not exceed 128 characters.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('uppercase')) {
              <div>
                Password must contain at least one uppercase letter.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('lowercase')) {
              <div>
                Password must contain at least one lowercase letter.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('digit')) {
              <div>
                Password must contain at least one digit.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('special')) {
              <div>
                Password must contain at least one special character.
              </div>
            }
            @if (passwordForm.get('newPassword')?.hasError('identical')) {
              <div>
                Password cannot have more than 2 identical characters in a row.
              </div>
            }
          </mat-error>
        }
      </div>

      <div class="form-field">
        <label for="confirmNewPassword">Confirm New Password</label>
        <mat-form-field>
          <input matInput formControlName="confirmNewPassword" type="password" class="form-input"
            id="confirmNewPassword-input" />
            @if (passwordForm.get('confirmNewPassword')?.errors?.['required']) {
              <mat-error>Confirm Password is
              required</mat-error>
            }
            @if (passwordForm.get('confirmNewPassword')?.errors?.['passwordMismatch']) {
              <mat-error>Passwords do not
              match</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="button-container">
          <button mat-raised-button color="primary" type="submit" [disabled]="passwordForm.invalid || isSubmitting"
            (click)="changePassword()">
            @if (isSubmitting) {
              <mat-spinner diameter="20"></mat-spinner>
            }
            @if (!isSubmitting) {
              <span>Change Password</span>
            }
          </button>
        </div>
      </form>
    </div>